import { LayoutService } from '@/app/layout/service/layout.service';
import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: '[app-footer]',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './app.footer.html'
})
/* v8 ignore start */
export class AppFooter {
/* v8 ignore stop */
    layoutService = inject(LayoutService);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());
}
